<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1QsEa9/tc-custom/9781473859432.jpg?1706326222279" alt="This image is the cover for the book Australia's Few and the Battle of Britain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Australia's Few and the Battle of Britain
      </h1>
      <p class="bookDescription body article font2">
        <p>During the summer and autumn of 1940, the Germans launched their Luftwaffe campaign to gain superiority over the RAF, especially Fighter Command. They were not successful, and this defeat marked a turning point in the Allies' favour. This is the story of eight Australian fighter pilots engaged in the Battle of Britain, the first major battle of World War II (or any war) fought entirely in the air. Jack Kennedy, Stuart Walch, Dick Glyde, Ken Holland, Pat Hughes, Bill Millington, John Crossman and Des Sheen  only one of them came home.A story we take for granted, here told afresh with insight and empathy.Professor Peter Stanley, UNSW CanberraIn telling the stories of some of the Australians who flew in the Battle of Britain, Kristen Alexander has combined academic rigour with compelling personal detail. She has demonstrated that the unknowns of the Battle are as fascinating as those who gained celebrity status. This is a book for those who know much about what happened in 1940 and those who don't.... Geoff Simpson, Trustee, Battle of Britain Memorial TrustThe lives of eight Australian fighter pilots, from backyard to cockpit and beyond, lovingly and expertly told.... Andy Wright, Aircrew Book Review</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristen Alexander
      </h2>
      
      <p class="authorDescription body article">Kristen Alexander is a Canberra-based writer and researcher. She has been writing about Australian pilots since 2002 and researching those in the Battle of Britain since 2008. She won the Military Historical Society of Australias Sabretache Writers Prize for Military History in 2012 and 2013. Her Jack Davenport: Beaufighter Leader was included on the RAAF chief of air forces 2010 reading list. This is her fourth book, published originally by NewSouth Publishing (Australia) in September 2014.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41883c11